module.exports = __webpack_public_path__ + "img/sonnenkopf.bbed8045.jpg";